import React, { useState } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import AreaStatus from "./AreaStatus";
import ControllerStatus from "./ControllerStatus";

// TabPanel helper component
function TabPanel({ children, value, index }) {
  return value === index ? <Box>{children}</Box> : null;
}

export default function MainAreaStatus() {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Paper sx={{ width: "100%", p: 1 }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Area status" />
        <Tab label="Controller status" />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <AreaStatus />
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <ControllerStatus />
      </TabPanel>
    </Paper>
  );
}
